import React, { useEffect } from 'react'
import Head from 'next/head'

import InspirationRevampApp from 'app/InspirationPage/pages/InspirationRevamp'
import { useSETrackEvent } from 'app/InspirationPage/hooks/useSETrackEvent'
import { useTogglesStore } from 'stores/toggles'

export const InspirationPage = () => {
  const isIdePraktikV2Enabled = useTogglesStore(
    (state) => state.toggles?.['ide-praktik-v2-enabled']
  )
  const { SETrackExploreOpenIdePraktik } = useSETrackEvent()

  useEffect(() => {
    if (isIdePraktikV2Enabled) return
    SETrackExploreOpenIdePraktik()

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isIdePraktikV2Enabled])

  return (
    <>
      <Head>
        <title>Ide Praktik - Ruang GTK</title>
        <meta name="description" content="Jelajahi konten praktik terbaik" />
      </Head>

      <InspirationRevampApp />
    </>
  )
}

InspirationPage.layoutOpts = {
  hasHeader: false,
  className: '[&>div]:flex [&>div]:flex-col [&>div]:flex-1',
}

export default InspirationPage
